<template>
  <nav aria-label="Breadcrumb" class="text-sm text-[#64748B] mb-4">
    <ol class="flex items-center gap-1.5 flex-wrap">
      <li v-for="(item, i) in items" :key="i" class="flex items-center gap-1.5">
        <router-link v-if="i < items.length - 1" :to="item.to" class="hover:text-[#2563EB] transition">{{ item.label }}</router-link>
        <span v-else class="text-[#1E293B] font-medium">{{ item.label }}</span>
        <svg v-if="i < items.length - 1" class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>
      </li>
    </ol>
  </nav>
</template>

<script setup>
defineProps({ items: { type: Array, required: true } });
</script>
